import React from "react";
import { useDispatch } from "react-redux";
import { updateBlogAsync } from "../../features/blog/blogSlice";

const BlogDetail = ({ blog }) => {
  const dispatch = useDispatch();

  const handleLike = () => {
    dispatch(
      updateBlogAsync({
        blogId: blog.id,
        updateValue: { likes: blog.likes + 1 },
      })
    );
  };

  const handleSave = () => {
    dispatch(
      updateBlogAsync({
        blogId: blog.id,
        updateValue: { isSaved: !blog.isSaved },
      })
    );
  };
  return (
    <main className="post">
      <img
        src={blog.image}
        alt={blog.title}
        className="w-full rounded-md"
        id="lws-megaThumb"
      />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {blog.title}
        </h1>
        <div className="tags" id="lws-singleTags">
          {blog.tags.map((tag, index) => (
            <span key={index}> #{tag} </span>
          ))}
        </div>
        <div className="btn-group">
          {/* <!-- handle like on button click --> */}
          <button
            className="like-btn"
            id="lws-singleLinks"
            onClick={handleLike}
          >
            <i className="fa-regular fa-thumbs-up"></i> {blog.likes}
          </button>

          <button
            className={`${blog.isSaved && "active"} save-btn`}
            id="lws-singleSavedBtn"
            onClick={handleSave}
          >
            <i className="fa-regular fa-bookmark"></i> Saved
          </button>
        </div>
        <div className="mt-6">
          <p>{blog.description}</p>
        </div>
      </div>
    </main>
  );
};

export default BlogDetail;
